module.exports = __webpack_public_path__ + "static/media/fox2-detroit.4282fa88.jpg";